<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<button class="token-picker-button" [matMenuTriggerFor]="tokenMenu">
  <span class="material-icons token-picker-icon">
    navigate_next
  </span>
</button>
<mat-menu #tokenMenu="matMenu" class="token-picker-dropdown">
  <button class="token-picker-option" *ngFor="let token of tokens" mat-menu-item
      (click)="onTokenChosen(token)">{{token.friendlyName | async}}</button>
</mat-menu>
